module.exports = __webpack_public_path__ + "img/P40-zh.cf081465.png";